import Vue from 'vue';
import {Form} from './utils';
import route from 'ziggy';
import { Ziggy } from './commons/dynamic-ziggy';

require('./bootstrap');
window.Form = Form;
require('./components/reviews');

Vue.filter('capitalize', require('./filters/capitalize').default);
Vue.component('button-loading', require('./components/shared/ButtonLoading').default);
Vue.component('rating-stars', require('./components/shared/RatingStars').default);

const laroute = {route: (name, params, absolute) => route(name, params, absolute, Ziggy).url()};
window.laroute = laroute;
window.route = laroute.route;

Vue.prototype.$laroute = laroute;
Vue.prototype.$http = window.axios;
Vue.prototype.$alert = (options = {}) => {
    const title = options.title || (options.type === 'error' ? 'Error!' : (options.type === 'success' ? 'Success!' : 'Warning!'));
    return new Promise((resolve, reject) => {
        swal.fire({
            title,
            text: options.message || '',
            type: options.type || 'warning'
        }).then(result => {
            if (result.value) {
                resolve(result);
            }
        }).catch(swal.noop);
    });
};

let app = new Vue({
    el: '#spark-app'
});
